import ApplicationInsights from './ApplicationInsights';
import setPerformance from './performance';
var Logger = /** @class */function () {
  function Logger() {}
  /**
   * 初始化Logger
   */
  Logger.initializeLogger = function (config, context) {
    if (!config.apiUrl) {
      return;
    }
    Logger.appInsights = new ApplicationInsights(config, context);
    if (config.performance) {
      setPerformance(Logger.trackPerformance, config.performanceMinFid, config.performanceMinLcp, config.performanceMinCls);
    }
  };
  /**
   * 自定义日志类型和信息
   * @param level
   * @param value
   * @param label
   * @param updateId
   */
  Logger.customTrack = function (level, value, label, updateId) {
    if (value === void 0) {
      value = {};
    }
    if (!Logger.appInsights || !Logger.appInsights.track) {
      return null;
    }
    return Logger.appInsights.track(level, value, label, updateId);
  };
  /**
   * 依赖项日志收集
   * @param value
   */
  Logger.trackDependency = function (value) {
    if (value === void 0) {
      value = {};
    }
    Logger.customTrack('warn', value, 'client_dependency');
  };
  /**
   * 异常收集
   * @param value
   */
  Logger.trackException = function (value) {
    if (value === void 0) {
      value = {};
    }
    Logger.customTrack('error', value, 'client_exception');
  };
  /**
   * 文件加载异常收集
   * @param value
   */
  Logger.trackFileException = function (value) {
    if (value === void 0) {
      value = {};
    }
    Logger.customTrack('error', value, 'fileException');
  };
  /**
   * 页面性能收集
   */
  Logger.trackPerformance = function (value, updateId) {
    if (value === void 0) {
      value = {};
    }
    return Logger.customTrack('info', value, 'performance', updateId);
  };
  /**
   * 用户点击事件收集
   * @param value
   */
  Logger.trackClickEvent = function (value) {
    if (value === void 0) {
      value = {};
    }
    Logger.customTrack('info', value, 'userClickEvent');
  };
  /**
   * site 为空
   * @param value
   */
  Logger.trackEmptySite = function (value) {
    if (value === void 0) {
      value = {};
    }
    Logger.customTrack('info', value, 'userEmptySite');
  };
  return Logger;
}();
export default Logger;